import React, { useEffect, useState } from 'react'
import { getTeamIc } from '../../../Utils'
import { WelcomeCon } from './styles'
import { ShareCon } from './styles'
import { Desc } from '../../../Components/Typography/Text.styles'
import { colors } from '../../../Components/consts'
import { SelectTeamData } from '../../../Api/Teams/team.types'
import { Box } from '../../../Components/Layout'

type WelcomeTeamParams = {
  team: SelectTeamData | null
  favoriteTeam: string
  link: string
}

export const WelcomeToTeam: React.FC<React.PropsWithChildren<WelcomeTeamParams>> = ({
  favoriteTeam,
  team,
  link,
}) => {
  const [copied, setCopied] = useState<string | null>(null)

  useEffect(() => {
    // Set timer to clear copied so user can click multiple times
    if (copied) {
      const timer = setTimeout(() => setCopied(''), 2000)
      return () => clearTimeout(timer)
    }
    return
  }, [copied])

  const handleClick = () => {
    navigator.clipboard.writeText(link)
    setCopied('Copied!')
  }

  return (
    <Box boxColor="dark">
      <WelcomeCon>
        <h2>{team?.welcomeText || `Welcome to the ${favoriteTeam}`}</h2>
        <img src={getTeamIc(favoriteTeam)} alt={`${favoriteTeam} Logo`} />
        <Desc textColor={colors.white}>
          {' '}
          Invite your friends to help build the next great fanbase
        </Desc>
        <ShareCon>
          <div className="textField">
            <div className="linkText">{link}</div>
          </div>
          <button onClick={handleClick}>{!copied ? 'Invite' : 'Copied!'}</button>
        </ShareCon>
      </WelcomeCon>
    </Box>
  )
}
